import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

interface TeamMember {
  id: string
  tenant_id: string
  email: string
  name: string | null
  avatar_url: string | null
  role: 'owner' | 'admin' | 'member'
  created_at: string
}

export function useTeam() {
  return useQuery({
    queryKey: ['team'],
    queryFn: () => api.get<TeamMember[]>('/dashboard/team'),
  })
}

interface InviteMemberData {
  email: string
  role: 'admin' | 'member'
}

export function useInviteMember() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: InviteMemberData) => {
      return api.post('/dashboard/team/invite', data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['team'] })
    },
  })
}

export function useRemoveMember() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (memberId: string) => {
      return api.delete(`/dashboard/team/${memberId}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['team'] })
    },
  })
}

export function useUpdateMemberRole() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ memberId, role }: { memberId: string; role: 'admin' | 'member' }) => {
      return api.patch(`/dashboard/team/${memberId}`, { role })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['team'] })
    },
  })
}
